export const validateEmail = email => email ? !!email.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/) : false

export const validatePhone = phone => {
    let valid = true;
    if (!phone) valid = false;
    else if (phone.length !== 10) valid = false;
    else if (parseInt(phone) < 0) valid = false;
    return valid
}